import { injectIntl } from "react-intl";
import { intlShape, formatDateTime } from "lcm-iot-commons";

type OwnProps = {
  signIn?: {
    time?: string;
    application?: string;
    ip?: string;
    browser_name?: string;
    browser_version?: string;
    device_type?: string;
    platform_name?: string;
    platform_version?: string;
  };
  intl?: intlShape;
};

const defaultProps: Partial<OwnProps> = {
  signIn: undefined,
  intl: undefined,
};

type Props = OwnProps & typeof defaultProps;

export function SignInItem({ signIn, intl }: Props) {
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const iconClassname = `small-icon lcm-iot-icon-${signIn.device_type}`;
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const signInTime = Date.parse(signIn.time);
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const headerText = `${signIn.application} - ${formatDateTime(signInTime, intl)}`;
  return (
    <li className="list-item">
      <div className="list-item-image">
        <span className={iconClassname} />
      </div>
      <div className="list-item-content">
        <div className="list-item-header">{headerText}</div>
        <div className="list-item-details">
          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
          {signIn.ip}
          {" - "}
          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
          {signIn.browser_name}
          {" - "}
          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
          {signIn.platform_name}
          {" ("}
          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
          {signIn.platform_version})
        </div>
      </div>
    </li>
  );
}

SignInItem.defaultProps = defaultProps;

export default injectIntl(SignInItem);
